// Central registry of brand + product imagery (lives in src/assets/, grouped by
// category). Importing through the bundler gives us hashed, cache-friendly URLs.

import logo from "@/assets/brand/logo.svg";
import logoTitleCn from "@/assets/brand/logo-title-cn.png";
import wechatQr from "@/assets/brand/微信二维码.png";

import screenFullStack from "@/assets/screens/Screen1-FullStack.png";
import screenHardware from "@/assets/screens/Screen2-Hardware.png";
import screenPlatform from "@/assets/screens/Screen3-Platform.png";
import screenDataRiver from "@/assets/screens/Screen4-DataRiver.png";
import fullStackCollab from "@/assets/screens/全栈协同.png";

import pvController from "@/assets/products/智能光伏控制器.png";
import switchgear from "@/assets/products/智能配电柜.png";
import industrialPc from "@/assets/products/工控机.png";
import energyDashboard from "@/assets/products/光伏能源数据大屏.png";
import energyBackend from "@/assets/products/能源管理后台.png";
import chillerDashboard from "@/assets/products/冷水机组运维大屏.png";
import llmService from "@/assets/products/大模型.png";

import partnerZxx from "@/assets/partners/智信鑫logo.jpg";
import partnerEnxi from "@/assets/partners/恩喜村logo.png";
import partnerRunda from "@/assets/partners/润达logo.svg";
import partnerMps from "@/assets/partners/公安部第三研究所logo.png";
import partnerEcnu from "@/assets/partners/华师大logo.svg";

export const assets = {
  logo,
  logoTitleCn,
  screenFullStack,
  screenHardware,
  screenPlatform,
  screenDataRiver,
  fullStackCollab,
  pvController,
  switchgear,
  industrialPc,
  energyDashboard,
  energyBackend,
  chillerDashboard,
  llmService,
  wechatQr,
  partnerZxx,
  partnerEnxi,
  partnerRunda,
  partnerMps,
  partnerEcnu,
};
